import ExpirationPremiumModal from 'src/components/Promotions/ExpirationPremiumModal.svelte';
import { fromMillisecondsToDays } from 'src/helpers/date_helper';
import { save_profile } from 'src/helpers/profile_helpers';
import { profile_data, user_data } from 'src/stores/account/user';
import { paypal_info } from 'src/stores/ui/promotions';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';
import { SubscriptionStatus, type PaypalInfoResponse } from 'src/types/Subscription';

export const ExpirationPremiumModalConfig = (): ModalConfig => {
	const paypalInfo = get(paypal_info) as PaypalInfoResponse;
	const nextBillingTime = paypalInfo.next_billing_time;
	const billingTotalDays = fromMillisecondsToDays(
		paypalInfo.next_billing_time,
		paypalInfo.last_billing_time,
	);
	const today = new Date();
	today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
	const billingTimePassed = fromMillisecondsToDays(today.toISOString(), paypalInfo.last_billing_time);

	if (paypalInfo.subscription_status === SubscriptionStatus.Active) {
		save_profile('isShowedExpirationPremium', 'no');
	}

	const profileData = get(profile_data);
	const userData = get(user_data);

	const expirationPremium =
		userData.premium &&
		(!profileData.isShowedExpirationPremium || profileData.isShowedExpirationPremium === 'no') &&
		paypalInfo.subscription_status === SubscriptionStatus.Cancelled &&
		+billingTotalDays - +billingTimePassed >= 0 &&
		+billingTotalDays - +billingTimePassed <= 10;

	return {
		id: 'expirationPremium',
		component: ExpirationPremiumModal,
		props: {
			priority: 70, // Medium priority
			nextBillingTime,
		},
		rules: [
			{
				check: () => expirationPremium,
				expected: true,
			},
			NoPremiumVoucherCheckRule,
		],
	};
};
